import { getSchema as getSchema1, uiSchema as uiSchema1, } from "./schema.indexContractBulkIndex.1";
import { getInitialValues } from "./schema.indexContractBulkIndex.utils";
// eslint-disable-next-line import/no-default-export
export default (function (extraData) {
    var initialValues = getInitialValues(extraData);
    return [
        {
            schema: getSchema1(extraData, initialValues),
            uiSchema: uiSchema1(extraData, initialValues),
        },
    ];
});
